var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg05(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 789,
    height: 413.746,
    viewBox: "0 0 789 413.746",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Union_1",
    x: 0,
    y: 0,
    width: 789,
    height: 387,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_2298",
    x: 150.873,
    y: 20.736,
    width: 344.294,
    height: 389.992,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -20,
    dy: 30,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_2302",
    x: 259.826,
    y: 23.742,
    width: 344.307,
    height: 390.004,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -20,
    dy: 20,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.388
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2579",
    "data-name": "Group 2579",
    transform: "translate(10.5 7.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -10.5, -7.5)",
    filter: "url(#Union_1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_1-2",
    "data-name": "Union 1",
    d: "M40,0H728a40,40,0,0,1,40,40V366H0V40A40,40,0,0,1,40,0Z",
    transform: "translate(10.5 7.5)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2544",
    "data-name": "Group 2544",
    transform: "translate(-120.336 -186.645)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2543",
    "data-name": "Group 2543",
    transform: "translate(349.336 241.546)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2541",
    "data-name": "Group 2541"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2297",
    "data-name": "Path 2297",
    d: "M360.685,342.122l171.57-99.047c3.08-1.769,5.874-1.946,7.928-.825v-.018l6.618,3.492-.29,10.2h-2.894V361.25c0,7.253-5.084,16.075-11.362,19.676l-170.086,98.2-2.694,5.216-6.631-3.452a2.443,2.443,0,0,0-.254-.15l-.023-.018v-.018c-2.014-1.188-3.23-3.715-3.23-7.289V361.808C349.336,354.578,354.412,345.756,360.685,342.122Z",
    transform: "translate(-349.336 -241.546)",
    fill: "#9f9f9f"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -239.5, -62.4)",
    filter: "url(#Path_2298)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2298-2",
    "data-name": "Path 2298",
    d: "M362.108,480.721,533.65,381.7c6.282-3.651,11.385-12.451,11.385-19.7V250.395c0-7.244-5.1-10.178-11.385-6.572L362.108,342.87c-6.277,3.62-11.367,12.437-11.367,19.708V474.162C350.741,481.415,355.83,484.341,362.108,480.721Z",
    transform: "translate(-104.87 -176.54)",
    fill: "#cbcbcb"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2299",
    "data-name": "Path 2299",
    d: "M545.037,276.693l-194.3,112.166v-30.27L545.037,246.4Z",
    transform: "translate(-344.368 -224.373)",
    fill: "#081523"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2547",
    "data-name": "Path 2547",
    d: "M392.555,323.989,485.9,270.122V262.5l-93.341,53.881Z",
    transform: "translate(-303.819 -167.458)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2548",
    "data-name": "Path 2548",
    d: "M378.565,309.149l48.968-28.284v-7.609l-48.968,28.278Z",
    transform: "translate(-353.283 -129.425)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2549",
    "data-name": "Path 2549",
    d: "M378.565,316.265l58.193-33.587v-7.63l-58.193,33.609Z",
    transform: "translate(-353.283 -123.091)",
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2542",
    "data-name": "Group 2542",
    transform: "translate(109.407 12.937)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2301",
    "data-name": "Path 2301",
    d: "M384.819,344.973l171.543-99.038c3.052-1.751,5.815-1.95,7.851-.88l.023,0,.118.072.113.059,6.5,3.819-3.229,5.965v109.14c0,7.257-5.08,16.079-11.371,19.694L384.819,482.833a10.4,10.4,0,0,1-1.388.689l-.671,3.561-5.865-3.4a1.264,1.264,0,0,1-.213-.127l-.15-.059v-.05c-1.905-1.225-3.075-3.7-3.075-7.176v-111.6C373.457,357.438,378.523,348.6,384.819,344.973Z",
    transform: "translate(-373.457 -244.398)",
    fill: "#cb9700"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -348.91, -75.34)",
    filter: "url(#Path_2302)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2302-2",
    "data-name": "Path 2302",
    d: "M386.152,483.6,557.7,384.566c6.26-3.638,11.371-12.451,11.371-19.708V253.26c0-7.239-5.112-10.183-11.38-6.563L386.152,345.735c-6.282,3.633-11.389,12.437-11.389,19.7V477.046C374.762,484.285,379.869,487.224,386.152,483.6Z",
    transform: "translate(-19.94 -166.41)",
    fill: "#fdbe00"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2303",
    "data-name": "Path 2303",
    d: "M569.072,294.148,374.762,406.293v-30.27l194.31-112.159Z",
    transform: "translate(-368.843 -175.57)",
    fill: "#081523"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2304",
    "data-name": "Path 2304",
    d: "M382.688,290.84c0,8.368,5.847,11.77,13.1,7.588,7.244-4.2,13.122-14.374,13.122-22.72,0-8.368-5.878-11.757-13.122-7.588C388.535,272.321,382.688,282.467,382.688,290.84Z",
    transform: "translate(-340.818 -166.824)",
    fill: "#d63a3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2305",
    "data-name": "Path 2305",
    d: "M378.565,293.221c0,8.373,5.851,11.761,13.117,7.57,7.235-4.182,13.117-14.356,13.117-22.711s-5.883-11.752-13.117-7.57C384.416,274.679,378.565,284.862,378.565,293.221Z",
    transform: "translate(-355.396 -158.405)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2306",
    "data-name": "Path 2306",
    d: "M410.244,295.154l24.919-14.378c2.581-1.506,4.658-4.84,4.658-7.525V254.269c0-2.653-2.091-3.61-4.658-2.118l-24.919,14.378c-2.572,1.5-4.658,4.858-4.658,7.525v18.978C405.586,295.7,407.672,296.642,410.244,295.154Z",
    transform: "translate(-259.856 -219.48)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2307",
    "data-name": "Path 2307",
    d: "M392.555,323.989,485.9,270.122V262.5l-93.341,53.881Z",
    transform: "translate(-305.931 -180.396)",
    fill: "#cb9700"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2308",
    "data-name": "Path 2308",
    d: "M378.565,309.149l48.968-28.284v-7.609l-48.968,28.278Z",
    transform: "translate(-355.395 -142.363)",
    fill: "#cb9700"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2309",
    "data-name": "Path 2309",
    d: "M378.565,316.265l58.193-33.587v-7.63l-58.193,33.609Z",
    transform: "translate(-355.395 -136.028)",
    fill: "#cb9700"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg05);
export default __webpack_public_path__ + "static/media/05.bc75af34d2b055c18c0eedccea52eeaf.svg";
export { ForwardRef as ReactComponent };